import React, { useState, useEffect } from "react";

// common function
import { tempHumStationLatLon } from "../scripts/station";
import { humMarker } from "../scripts/humMarker";
import { fetchingTime } from "../../../../config/fetching";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/humMap.scss";
// mapTitle sheet
import "../scss/mapTitleMap.scss";

// leaflet css
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import "leaflet-defaulticon-compatibility";

// Openstreetmap components
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  ZoomControl,
  useMapEvents,
} from "react-leaflet";

// L component
import * as Leaflet from "leaflet";

// Watermark
import Watermark from "../../../../resources/image/watermark.jpg";
import { getHumInformation } from "../../../service/apiWeatherInfoService";

//#region Map Watermark
const WatermarkControl = () => {
  const map = useMap();
  const watermark = map.getContainer().querySelector(".watermark");

  if (!watermark) {
    const watermark = new Leaflet.Control({ position: "bottomleft" });
    watermark.onAdd = function (map) {
      var div = Leaflet.DomUtil.create("div", "watermark");
      div.innerHTML = "<img src='" + Watermark + "' width='75' height='75'>";
      return div;
    };
    watermark.addTo(map);
  }

  return null;
};

//#endregion END

type Props = { enable: number; autoUpdate?: boolean };
type humInfo_Props = { station: string; hum: string; time: string };

function HumMap({ enable, autoUpdate }: Props) {
  const [isMapOn, setIsMapOn] = useState<React.Key>(0);
  const [humArray, setHumArray] = useState<Array<humInfo_Props>>([]);
  const [time, setTime] = useState<string>("");

  const [zoomLevel, setZoomLevel] = useState<number>(11);

  const position: Leaflet.LatLngExpression = [22.35, 114.125];

  // zoom change
  const ZoomListener = () => {
    useMapEvents({
      zoomend: (event) => {
        const map = event.target;
        const zoom = map.getZoom();

        setZoomLevel(zoom);
      },
    });
    return null;
  };

  async function getFetchHumInfomation() {
    await getHumInformation()
      .then((response) => {
        return response.data.data;
      })
      .then((data) => {
        setHumArray(data);
        setTime(data[0].time);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      if (autoUpdate === true) {
        getFetchHumInfomation();
      }
    };

    getFetchHumInfomation(); // Initial fetch

    let intervalId = setInterval(() => {
      fetchData();
    }, fetchingTime);

    return () => {
      clearInterval(intervalId);
    };
  }, [autoUpdate]);

  useEffect(() => {
    setIsMapOn(enable);

    // Reset the zoom level
    setZoomLevel(11);
  }, [enable]);

  return (
    <div className="mapContainer">
      <MapContainer
        zoom={11}
        maxZoom={12}
        minZoom={11}
        zoomControl={false}
        center={position}
        scrollWheelZoom={false}
        key={isMapOn}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <ZoomControl position="topright" />

        <WatermarkControl />

        <ZoomListener />

        {humArray.map((item) => {
          if (
            (item.station === "King's Park" || item.station === "HK Park") &&
            zoomLevel === 11
          ) {
            return null;
          } else {
            return (
              <Marker
                key={"hum-" + item.station}
                position={tempHumStationLatLon(item.station)}
                icon={humMarker(item.hum)}
              />
            );
          }
        })}
      </MapContainer>
      <div className="mapDescription">
        <div>各地相對濕度(%)</div>
        <div>
          {time.substr(4, 2)}月{time.substr(6, 2)}日 {time.substr(8, 2)}:
          {time.substr(10, 2)}更新
        </div>
      </div>
    </div>
  );
}

export default HumMap;
